import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function PasswordResetForm() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const token = new URLSearchParams(location.search).get('token');

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleChangeConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/reset_password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token, new_password: password }),
      });

      if (!response.ok) {
        throw new Error('Password reset failed. Please try again.');
      }

      const data = await response.json();
      console.log('Password reset successful', data);

      setMessage('Your password has been reset successfully. You will be redirected to the login page.');
      setTimeout(() => navigate('/login'), 3000);

    } catch (error) {
      console.error('Password reset error:', error);
      setError(error.message);
    }
  };

  return (
    <div className='login-title fade-in'>
      <h1>Reset Password</h1>
      {error && <p className="reset-password-error-message">{error}</p>}
      {message && <p className="reset-password-success-message">{message}</p>}
      <form onSubmit={handleSubmit} className="user-registration-form">
        <div>
          <label htmlFor="password">New Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={password}
            onChange={handleChangePassword}
            required
          />
        </div>
        <div>
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={confirmPassword}
            onChange={handleChangeConfirmPassword}
            required
          />
        </div>
        <div className="button-container">
          <button className="login-button" type="submit">Reset Password</button>
        </div>
      </form>
    </div>
  );
}

export default PasswordResetForm;
